import { useAppSelector } from 'src/store/hooks'
import {
  selectSectionById,
  selectCoursesBySection,
  selectCompletedCourses,
  selectIncompleteAssignmentCourses,
} from 'src/v3/self-paced/self-paced.slice'
import { TEXAS_JURISPRUDENCE_COURSE_IDS } from 'src/v3/settings/settings.slice'
import { useNavigate, useParams } from 'react-router-dom'
import { ReactElement } from 'react'
import { Box, Typography, Card, CardMedia } from '@mui/material'
import { onCourseImageError } from 'src/v3/self-paced/utils/course-thumbnail'
import { assignedMarker, completeMarker } from './components/markers'
import { Course } from '../core/types'

export default (): ReactElement => {
  let { sectionId } = useParams()
  let navigate = useNavigate()

  let section = useAppSelector(selectSectionById(sectionId ?? ''))
  let rawCourses = useAppSelector(selectCoursesBySection(sectionId ?? ''))
  let courses = rawCourses.filter(
    (c) => !TEXAS_JURISPRUDENCE_COURSE_IDS.includes(c.id),
  )
  let completedCourses = useAppSelector(selectCompletedCourses)
  let incompleteAssignmentCourses = useAppSelector(
    selectIncompleteAssignmentCourses,
  )

  return (
    <>
      <Box sx={{ px: 3, py: 4 }}>
        <Typography variant="h1" component="h1">
          {section?.name}
        </Typography>
      </Box>
      <Box className="mt-4 px-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {courses.map((course: Course) => {
            let isCompleted = completedCourses.some((cc) => cc === course.id)
            let isAssigned = incompleteAssignmentCourses.includes(course.id)

            return (
              <Box
                key={course.id}
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                  position: 'relative',
                }}
                onClick={() => navigate(`/self-paced/course/${course.id}`)}
              >
                {isCompleted && !isAssigned && completeMarker}
                {isAssigned && assignedMarker}
                <Card
                  sx={{
                    bgcolor: 'transparent',
                    boxShadow: 'none',
                    opacity: isCompleted && !isAssigned ? 0.4 : 1,
                    border: 'none',
                    borderRadius: 2,
                    overflow: 'hidden',
                  }}
                >
                  <CardMedia
                    component="img"
                    image={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${course.imageName}`}
                    onError={(event) =>
                      onCourseImageError(event, course.imageName)
                    }
                    alt={course.displayName}
                    sx={{
                      width: '100%',
                      height: 'auto',
                      aspectRatio: '16/9',
                      objectFit: 'cover',
                    }}
                  />
                </Card>
              </Box>
            )
          })}
        </div>
      </Box>
    </>
  )
}
